import { SystemMessageService } from './system-message.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { SYSTEM_MESSAGE_TYPE, SystemMessage } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class SystemMessageResolverBase implements Resolve<SystemMessage> {

  constructor(protected service: SystemMessageService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SystemMessage> {
    const key: number = SYSTEM_MESSAGE_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



